/**
 * Oktaユーザ名取得条件VO
 *
 * @export GetOktaUserNameModel
 * @class GetOktaUserNameModel
 */
export class GetOktaUserNameModel {
  // ユーザID
  public UserId = String('');

  // 反映対象行インデックス（サーバ送信しない）
  public TargetIndex = Number(0);
  // 反映対象項目名（サーバ送信しない）
  public TargetItemName = String('');
}
